import { render } from "./PropertyBuildings.vue?vue&type=template&id=038944d0"
import script from "./PropertyBuildings.vue?vue&type=script&lang=js"
export * from "./PropertyBuildings.vue?vue&type=script&lang=js"

import "./PropertyBuildings.vue?vue&type=style&index=0&id=038944d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__